// Блок видео под формой — автоплей при скролле, фуллскрин по клику
document.addEventListener('DOMContentLoaded', function() {
    var wrapper = document.querySelector('.bottom-video-wrapper');
    if (!wrapper) return;

    var poster = wrapper.querySelector('.bottom-video-poster');
    var playerWrap = wrapper.querySelector('.bottom-video-player');
    var videoFull = playerWrap ? playerWrap.querySelector('video') : null;
    var videoPreview = poster ? poster.querySelector('.bottom-video-preview') : null;
    var isAutoPlaying = false;

    // Автоплей при скролле
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                if (!isAutoPlaying && videoPreview) {
                    videoPreview.muted = true;
                    videoPreview.play().catch(function() {});
                    isAutoPlaying = true;
                }
            } else {
                if (isAutoPlaying && videoPreview) {
                    videoPreview.pause();
                    isAutoPlaying = false;
                }
            }
        });
    }, { threshold: 0.3 });

    observer.observe(wrapper);

    // Клик — фуллскрин со звуком
    if (poster && videoFull) {
        poster.addEventListener('click', function() {
            var currentTime = videoPreview ? videoPreview.currentTime : 0;
            videoPreview.pause();
            isAutoPlaying = false;

            poster.style.display = 'none';
            playerWrap.style.display = 'block';

            videoFull.currentTime = currentTime;
            videoFull.muted = false;
            videoFull.play().catch(function() {});

            // Фуллскрин
            if (videoFull.requestFullscreen) {
                videoFull.requestFullscreen();
            } else if (videoFull.webkitRequestFullscreen) {
                videoFull.webkitRequestFullscreen();
            } else if (videoFull.webkitEnterFullscreen) {
                videoFull.webkitEnterFullscreen();
            }
        });

        // Выход из фуллскрина — вернуть превью
        function onFullscreenChange() {
            var isFullscreen = document.fullscreenElement || document.webkitFullscreenElement;
            if (!isFullscreen && playerWrap.style.display === 'block') {
                var currentTime = videoFull.currentTime;
                videoFull.pause();
                playerWrap.style.display = 'none';
                poster.style.display = 'block';

                if (videoPreview) {
                    videoPreview.currentTime = currentTime;
                    videoPreview.muted = true;
                    videoPreview.play().catch(function() {});
                    isAutoPlaying = true;
                }
            }
        }

        document.addEventListener('fullscreenchange', onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', onFullscreenChange);

        videoFull.addEventListener('ended', function() {
            videoFull.pause();
            playerWrap.style.display = 'none';
            poster.style.display = 'block';
            if (videoPreview) {
                videoPreview.currentTime = 0;
                videoPreview.muted = true;
                videoPreview.play().catch(function() {});
                isAutoPlaying = true;
            }
        });
    }
});
